import { useTranslation } from "react-i18next";

import contentTypesConst from "astrid-distribution/src/constants/contentTypes";
import formatBytes from "astrid-helpers/src/formatBytes";
import msToTime from "astrid-helpers/src/msToTime";

import { reorderColumn } from "../../ui/utils/columns";

export default function useArtifactFilesTableColumns({ disabled, contentTypes, onReorderFiles } = {}) {
	const { t } = useTranslation();

	const isWav = contentTypes.includes(contentTypesConst.WAV);
	const isMp3 = contentTypes.includes(contentTypesConst.MP3);

	const isAudio = isWav || isMp3;
	const isEpub = contentTypes.includes(contentTypesConst.EPUB) || contentTypes.includes(contentTypesConst.PDF);

	return [
		{
			id: "sequence",
			Header: t("sequence", "Sequence"),
			collapsing: true,
			Cell: ({ row, data }) => {
				const index = data.indexOf(row) + 1;

				return index.toString().padStart(3, "0");
			},
		},
		{
			id: "name",
			Header: t("name", "Name"),
		},
		{
			id: "contentType",
			Header: t("contentType", "Content-Type"),
		},
		{
			id: "duration",
			Header: t("duration", "Duration"),
			accessor: ({ duration }) => (duration ? msToTime(duration * 1000, false) : null),
			loading: true,
			hidden: !isAudio,
		},
		{
			id: "channels",
			Header: t("channels", "Channels"),
			accessor: ({ format }) => (format ? (format.channels > 1 ? "Stereo" : "Mono") : null),
			loading: true,
			hidden: !isAudio,
		},
		{
			id: "sampleRate",
			Header: t("sampleRate", "Sample Rate"),
			accessor: ({ format }) => (format ? `${format.sampleRate / 1000} kHz` : null),
			loading: true,
			hidden: !isAudio,
		},
		{
			id: "bitDepth",
			Header: t("bitDepth", "Bit Depth"),
			accessor: ({ format }) => format?.bitDepth || null,
			loading: true,
			hidden: !isWav,
		},
		{
			id: "bitRate",
			Header: t("bitRate", "Bit rate"),
			accessor: ({ format }) => (format ? `${format.bitRate / 1000} kbps` : null),
			loading: true,
			hidden: !isMp3,
		},
		{
			id: "epubVersion",
			Header: t("version", "Version"),
			accessor: ({ format }) => format?.version || null,
			hidden: !isEpub,
		},
		{
			id: "size",
			Header: t("size", "Size"),
			accessor: ({ size }) => formatBytes(size),
		},
		!disabled && reorderColumn({ onReorder: onReorderFiles }),
	];
}
